.listButtons {
  padding-left: 0;
}
.listButtons li {
  list-style: none;
  margin-bottom: -1px;
}
.listButtons button {
  text-align: left;
  background: transparent;
  cursor: pointer;
}
.listButtons li:first-child button {
  border-radius: 0.625rem 0.625rem 0px 0px;
}
.listButtons li:last-child button {
  border-radius: 0px 0px 0.625rem 0.625rem;
}
